//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moduleName from '~/static/moduleName.json';

export default {
  name: "addNewModule",
  data: function data() {
    var moduleNameL = [];
    moduleName.forEach(function (mName) {
      moduleNameL.push(mName);
    });

    this.$store.commit('management/setModuleName', moduleNameL);

    return {
      newModule: '',
      moduleNameList: this.$store.state.management.moduleNames
    };
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.$store.commit('management/setModuleName', moduleName);
    });
  },

  methods: {
    addNewModule: function addNewModule() {
      this.$emit('addNewModule', this.newModule);
      // this.$store.commit('management/addNewModule', this.moduleName);
    },
    removeModuleName: function removeModuleName(item) {
      console.log('\n\n ========== Add New Module Comp <| removeModuleName() ==========\n', item.value, '\n -----------------');
      this.$emit('removeModuleName', item);
      // this.$store.commit('management/removeModuleName', moduleName);
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/dashboard/management/addNewModule.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/dashboard/management/addNewModule.vue
// module chunks = 0